import { render, staticRenderFns } from "./PanelResponsable.vue?vue&type=template&id=291f423c"
import script from "./PanelResponsable.vue?vue&type=script&lang=js"
export * from "./PanelResponsable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports